/**
 * Legacy → current route redirect map.
 *
 * Lovable hosting cannot serve real HTTP 301s (no `_redirects`,
 * `vercel.json`, etc.), so this module implements client-side redirects
 * via React Router's `<Navigate replace />`. Crawlers that execute JS
 * (Googlebot) will follow them, and the destination route's canonical
 * tag (see `src/components/RouteCanonical.tsx`) consolidates ranking
 * signals onto the new URL.
 *
 * To add a redirect:
 *   1. Add an entry below: `{ from: "/old-path", to: "/new-path" }`.
 *   2. That's it — `<LegacyRedirects />` is already mounted in App.tsx
 *      and will register a wildcard route for each entry.
 *
 * Notes:
 *   - `from` MUST start with "/" and SHOULD NOT collide with a real
 *     route in App.tsx (real routes win).
 *   - For prefix redirects (e.g. /coaches/:slug → /c/:slug), use the
 *     `:param` syntax in both `from` and `to`. The matched params are
 *     forwarded automatically.
 *   - Search params and hash are preserved by default.
 */

export type LegacyRedirect = {
  from: string;
  to: string;
};

export const LEGACY_REDIRECTS: LegacyRedirect[] = [
  // No legacy routes yet. Add entries here as URLs evolve, e.g.:
  // { from: "/coaches/:slug", to: "/c/:slug" },
  // { from: "/old-pricing", to: "/pricing" },
];
